import { InputField, Checkbox, Label } from "@jana-technology/platform-ui";

import { keepStrings } from "contexts/filters/helpers";

import { handleFilterCheckbox } from "./helpers";
import type { RiskAssetFilterItemGridProps } from "./types";

export const RiskAssetFilterItemGrid = ({
  children,
  items,
  setState,
  stateItems,
  stateKey,
  baseFilters,
}: RiskAssetFilterItemGridProps) => {
  const allChecked =
    stateItems.length === items.length
      ? true
      : stateItems.length === 0
        ? false
        : "indeterminate";

  return (
    <div className="grid max-h-36 grid-cols-2 gap-3 overflow-y-auto rounded-sm border border-grey-300 p-4">
      <InputField direction="row">
        <Checkbox
          id={`checkbox-${items[0].value}-all`}
          checked={allChecked}
          onCheckedChange={(checked) => {
            setState((state) => ({
              ...state,
              [stateKey]: checked
                ? baseFilters?.[stateKey]?.filter(keepStrings)
                : [],
            }));
          }}
          value="all"
        />
        <Label htmlFor={`checkbox-${items[0].value}-all`}>All</Label>
      </InputField>
      {items.map((item) => (
        <InputField key={item.value} direction="row">
          <Checkbox
            id={`checkbox-${item.value}`}
            checked={stateItems.includes(item.value)}
            onCheckedChange={(checked) => {
              setState((state) =>
                handleFilterCheckbox(state, stateKey, item.value, checked),
              );
            }}
            value={item.value}
          />
          <Label htmlFor={`checkbox-controlled-${item.value}`}>
            {item.children}
          </Label>
        </InputField>
      ))}

      {children}
    </div>
  );
};

export default RiskAssetFilterItemGrid;
